import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class InternetBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Internet.toLowerCase();
    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      { title: 'INTERNET.receipts', to: `/benefits/${benefit}/receipts` },
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
